import { render, staticRenderFns } from "./biaozhunhuaLegislation.vue?vue&type=template&id=62b03d48&scoped=true"
import script from "./biaozhunhuaLegislation.vue?vue&type=script&lang=js"
export * from "./biaozhunhuaLegislation.vue?vue&type=script&lang=js"
import style0 from "./biaozhunhuaLegislation.vue?vue&type=style&index=0&id=62b03d48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b03d48",
  null
  
)

export default component.exports